import Vue from "vue";

export default function ({ $axios, redirect, store }) {
  $axios.onRequest((config) => {
    if (!navigator.onLine) {
      Vue.prototype.$toast.error("خطا", "اتصال به اینترنت برقرار نیست", {
        position: "topLeft",
        rtl: true,
      });
    }
  });

  $axios.onResponse((response) => {
    // console.log(response);
  });

  $axios.onError((error) => {
    if (error.response.status === 401) {
      if (store.$auth.state.loggedIn) {
        store.$auth.logout();
      }
      redirect("/login");
    } else if (error.response.status === 422) {
      const slugError = error.response.data?.errors?.slug;
      const bodyError = error.response.data?.errors?.body;

      let errorText = "لطفا مقادیر وارد شده در فرم را بررسی نمایید.";

      if (slugError) {
        errorText = "Slug وارد شده تکراری هست. لطفا آن را تغییر دهید.";
      } else if (bodyError) {
        errorText = "فیلد توضیحات نمی تواند خالی باشد!";
      }

      Vue.prototype.$swal({
        type: "warning",
        text: errorText,
        confirmButtonColor: "#2632d6",
        confirmButtonText: "تایید",
      });
    }

    // let errorObject = JSON.parse(JSON.stringify(error));
    // console.log(errorObject);
  });
}
